import {DEFAULT_DURATION} from '../../animations/collapse.animation';
import {animate, AUTO_STYLE, state, style, transition, trigger} from '@angular/animations';
import {AppTourService} from '../../services/app-tour/app-tour.service';
import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {StorageService} from '../../services/storage/storage.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Store} from '@ngxs/store';
import {UtilitiesService} from '../../services/utilities-service/utilities.service';
import {menuActiveAnimation} from '../../animations/menu.animation';
import {MainMenuHelperClass} from '../../class/helper/main-menu.helper.class';


export interface IMenu {
  name: string;
  subItems?: IMenu[];
  iconUrl?: string;
  iconClass?: string;
  url?: string;
  visible?: boolean;
  params?: any;
}

@Component({
  selector: 'app-dropdown-menu',
  templateUrl: './dropdown-menu.component.html',
  styleUrls: ['./dropdown-menu.component.scss'],
  animations: [
    menuActiveAnimation,
    trigger('collapse', [
      state('false', style({ height: AUTO_STYLE, visibility: AUTO_STYLE })),
      state('true', style({ height: '0', visibility: 'hidden' })),
      transition('false => true', animate(DEFAULT_DURATION + 'ms ease-in')),
      transition('true => false', animate(DEFAULT_DURATION + 'ms ease-out'))
    ])
  ]
})
export class DropdownMenuComponent extends MainMenuHelperClass implements OnInit, OnDestroy {
  @Input() innerWidth: number;
  @Input() hasPanelTemplate: boolean;

  constructor(
    public storageService: StorageService,
    public router: Router,
    public store: Store,
    public utilityService: UtilitiesService,
    public activatedRoute: ActivatedRoute,
    public appTourService: AppTourService
  ) {
    super(storageService, router, store, utilityService, activatedRoute, appTourService);
  }

  ngOnInit(): void {
    this.initValuesHttp().then();
  }

  ngOnDestroy(): void {
    this.$user.unsubscribe();
    this.$clinic.unsubscribe();
    this.$userClinics.unsubscribe();
    this.$active.unsubscribe();
  }
}
